import { useStore } from 'zustand';
import { createStore } from 'zustand';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';

const SUPPRESS_CONDITION_ACTIVATE_MS = 300;

type TreeDndUiStore = {
  editingConditionId: string | null;
  requestConditionEditor: (id: string) => void;
  clearConditionEditor: () => void;
  suppressConditionActivateUntil: number;
  suppressConditionActivate: () => void;
  isConditionActivateSuppressed: () => boolean;
  addSheetParentPath: NodePath | null;
  requestAddSheet: (parentPath: NodePath) => void;
  clearAddSheet: () => void;
};

export const treeDndUiStore = createStore<TreeDndUiStore>((set, get) => ({
  editingConditionId: null,

  requestConditionEditor: (id) => {
    set({ editingConditionId: id });
  },

  clearConditionEditor: () => {
    set({ editingConditionId: null });
  },

  suppressConditionActivateUntil: 0,

  suppressConditionActivate: () => {
    set({
      suppressConditionActivateUntil:
        Date.now() + SUPPRESS_CONDITION_ACTIVATE_MS,
    });
  },

  isConditionActivateSuppressed: () => {
    return Date.now() < get().suppressConditionActivateUntil;
  },

  addSheetParentPath: null,

  requestAddSheet: (parentPath) => {
    set({ addSheetParentPath: parentPath });
  },

  clearAddSheet: () => {
    set({ addSheetParentPath: null });
  },
}));

export function useTreeDndUiStore<T>(
  selector: (state: TreeDndUiStore) => T
): T {
  return useStore(treeDndUiStore, selector);
}
